import { loadView } from '@/helper/utils'
import { lpLayout } from '@/components/layouts/Lp'

export default {
  path: '/lp/:lpCode/:code',
  name: 'Lp',
  component: lpLayout(loadView('lp/Lp'))
}
